export const ApproachTabsContent = [
    {
        name: 'Mental Health Counseling',
        content: (
            <>
                <p>
                    We offer individual and group therapy sessions for people dealing with trauma, depression, anxiety, or emotional distress. Sessions are conducted by licensed professionals and trained volunteers.
                </p>
            </>
        ),
    },
    {
        name: 'Rehabilitation Programs',
        content: (
            <>
                <p>
                    Our rehabilitation services support individuals recovering from substance abuse, addiction, or mental breakdowns. With structured support and care, we help people rebuild their lives.
                </p>
            </>
        ),
    },
    {
        name: 'Psychosocial Support',
        content: (
            <>
                <p>
                    We focus on the human experience — offering mentorship, therapy, reintegration support, and community healing programs.
                </p>
            </>
        ),
    },
    {
        name: 'Community Education',
        content: (
            <>
                <p>
                    Through workshops and awareness campaigns, we help reduce stigma and empower communities to care for mental health proactively.
                </p>
            </>
        ),
    },
];
